var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrueBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.031 7.28104L10.031 19.281C9.96139 19.3508 9.87867 19.4061 9.78762 19.4438C9.69657 19.4816 9.59898 19.501 9.50042 19.501C9.40186 19.501 9.30426 19.4816 9.21321 19.4438C9.12216 19.4061 9.03945 19.3508 8.96979 19.281L3.71979 14.031C3.57906 13.8903 3.5 13.6994 3.5 13.5004C3.5 13.3014 3.57906 13.1105 3.71979 12.9698C3.86052 12.8291 4.05139 12.75 4.25042 12.75C4.44944 12.75 4.64031 12.8291 4.78104 12.9698L9.50042 17.6901L20.9698 6.21979C21.1105 6.07906 21.3014 6 21.5004 6C21.6994 6 21.8903 6.07906 22.031 6.21979C22.1718 6.36052 22.2508 6.55139 22.2508 6.75042C22.2508 6.94944 22.1718 7.14031 22.031 7.28104Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueBlack);
export default __webpack_public_path__ + "static/media/true-black.bf07b246a33d8146b33d184cb0de334b.svg";
export { ForwardRef as ReactComponent };